import React from 'react';
import { Link } from 'react-router-dom';
import { departmentPath } from '../utils/departmentRouting';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3001';

type Department = {
  id: string;
  name: string;
  slug: string;
  description?: string | null;
  heroImageUrl?: string | null;
};

export default function DepartmentsLandingPage() {
  const [items, setItems] = React.useState<Department[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const res = await fetch(`${API_BASE}/departments/public`);
        if (!res.ok) return;
        const data = (await res.json()) as Department[];
        if (!cancelled) setItems(Array.isArray(data) ? data : []);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-10 sm:px-6">
      <div className="mx-auto max-w-6xl">
        <h1 className="text-3xl font-extrabold text-slate-900">
          Choose a department
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          Each department has its own storefront, categories, and catalog.
        </p>
        {loading ? <p className="mt-6 text-sm text-slate-600">Loading...</p> : null}
        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <Link
              key={item.id}
              to={departmentPath(item.slug)}
              className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:border-slate-300"
            >
              <div className="h-40 bg-slate-100">
                {item.heroImageUrl ? (
                  <img
                    src={
                      item.heroImageUrl.startsWith('http')
                        ? item.heroImageUrl
                        : `${API_BASE}${item.heroImageUrl}`
                    }
                    alt={item.name}
                    className="h-full w-full object-cover"
                  />
                ) : null}
              </div>
              <div className="p-5">
                <p className="text-base font-semibold text-slate-900">{item.name}</p>
                <p className="mt-1 text-sm text-slate-600">
                  {item.description || 'Open this department'}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
